<div class="details-header">
  <div class="header-row">
    <h1>
      @if (store.storageLocation(); as storageLocation) {
        {{ storageLocation.label }} - Artikelübersicht
      } @else {
        Artikelübersicht
      }
    </h1>
  </div>

  <a routerLink="/lagerorte" class="back-link">
    <mat-icon>arrow_back</mat-icon>
    Zurück
  </a>
</div>

@if (!store.storageLocation() && !store.storageLocationLoading()) {
  <div class="form-box">
    <p>Der Lagerort konnte nicht gefunden werden.</p>
  </div>
} @else {
  <div class="form-box">
    <mat-form-field class="search-field">
      <mat-label>Suchen</mat-label>
      <input matInput [value]="searchTerm()" (input)="search($any($event.target).value)" />
      @if (searchTerm()) {
        <button matIconButton matSuffix type="button" aria-label="Suche zurücksetzen" (click)="search('')">
          <mat-icon>clear</mat-icon>
        </button>
      } @else {
        <mat-icon matSuffix>search</mat-icon>
      }
    </mat-form-field>

    @if (store.loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="table-container">
      <table mat-table [dataSource]="store.entities()">
        <ng-container matColumnDef="photo">
          <th mat-header-cell *matHeaderCellDef>Bild</th>
          <td mat-cell *matCellDef="let row">
            <img [src]="row.article?.photo || defaultImage" alt="" />
          </td>
        </ng-container>

        <ng-container matColumnDef="internalId">
          <th mat-header-cell *matHeaderCellDef>Artikelnummer</th>
          <td mat-cell *matCellDef="let row">{{ row.article?.internalId }}</td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Artikelname</th>
          <td mat-cell *matCellDef="let row">{{ row.article?.title }}</td>
        </ng-container>

        <ng-container matColumnDef="actualStock">
          <th mat-header-cell *matHeaderCellDef>Verfügbar</th>
          <td mat-cell *matCellDef="let row">{{ row.actualStock }}</td>
        </ng-container>

        <ng-container matColumnDef="reservedStock">
          <th mat-header-cell *matHeaderCellDef>Reserviert</th>
          <td mat-cell *matCellDef="let row">{{ row.reservedStock }}</td>
        </ng-container>

        <ng-container matColumnDef="autoOrderLessStock">
          <th mat-header-cell *matHeaderCellDef>Eiserner Bestand</th>
          <td mat-cell *matCellDef="let row">{{ row.autoOrderLessStock }}</td>
        </ng-container>

        <ng-container matColumnDef="notificationStock">
          <th mat-header-cell *matHeaderCellDef>Meldebestand</th>
          <td mat-cell *matCellDef="let row">{{ row.notificationStock }}</td>
        </ng-container>

        <ng-container matColumnDef="targetStock">
          <th mat-header-cell *matHeaderCellDef>Zielbestand</th>
          <td mat-cell *matCellDef="let row">{{ row.targetStock }}</td>
        </ng-container>

        <ng-container matColumnDef="storageStatus">
          <th mat-header-cell *matHeaderCellDef>Lagerstatus</th>
          <td mat-cell *matCellDef="let row">
            <span class="storage-status" [class]="'storage-status status-' + row.storageStatus"
              [matTooltip]="storageStatusLabels[row.storageStatus] ?? ''"
              [attr.aria-label]="storageStatusLabels[row.storageStatus] ?? null">
              @switch (row.storageStatus) {
                @case (1) {
                  <mat-icon>block</mat-icon>
                }
                @case (2) {
                  <mat-icon>error_outline</mat-icon>
                }
                @default {
                  <span class="status-dot"></span>
                }
              }
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="buyStock">
          <th mat-header-cell *matHeaderCellDef>In den Warenkorb</th>
          <!-- Klicks in das Eingabefeld sollen nicht zur Artikeldetailseite führen -->
          <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="amount-field">
              <mat-label>Anzahl</mat-label>
              <input #amountInput matInput type="number" min="0"
                [step]="row.article?.samplingStep ?? 1"
                [max]="row.actualStock"
                [disabled]="row.actualStock === 0"
                [value]="amounts()[row.id] ?? ''"
                (change)="setAmount(row, amountInput)"
                (keydown.enter)="setAmount(row, amountInput); addToCart()" />
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="article-row" (click)="openArticle(row)"></tr>
        <tr class="mat-mdc-row" *matNoDataRow>
          <td class="mat-mdc-cell no-data-cell" [attr.colspan]="displayedColumns.length">
            @if (!store.loading()) {
              Keine passenden Artikel gefunden.
            }
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [length]="store.total()"
      [pageIndex]="store.pageIndex()"
      [pageSize]="store.pageSize()"
      [pageSizeOptions]="pageSizeOptions"
      (page)="changePage($event)">
    </mat-paginator>

    <div class="form-action-row">
      <button matButton="filled" color="primary" type="button" class="save-btn" (click)="addToCart()">
        In den Warenkorb
        @if (selectedCount() > 0) {
          ({{ selectedCount() }})
        }
        <mat-icon iconPositionEnd>shopping_cart</mat-icon>
      </button>
    </div>
  </div>
}
